export default String.raw`.bannerPromo__products .card-product__image{max-height:135px}.bannerPromo__placeholder::after{content:"Tablet"}`